import { motion } from 'framer-motion';
import styled from 'styled-components';
import arrowLeft from 'assets/icons/arrow-left.svg';
import arrowRight from 'assets/icons/arrow-right.svg';
import { fonts } from 'styles';

export const Container = styled.div`
  display: flex;
  column-gap: 72px;
  width: 100%;
  margin-top: -2px;

  @media screen and (max-width: 1140px) {
    flex-direction: column;
  }
`;

export const GroupGalleries = styled.div`
  display: flex;
  width: max-content;

  @media screen and (max-width: 1140px) {
    flex-direction: column;
  }
`;

export const Wrapper = styled.div`
  position: relative;

  @media screen and (max-width: 1140px) {
    margin-top: -2px;
  }
`;

export const Frame = styled.div`
  width: 160px;
  height: 160px;
  overflow: hidden;
  position: relative;
  background-color: white;
  border: 2px solid #111;

  &.shoes {
    border-left: 0;
  }

  @media screen and (max-width: 1140px) {
    width: 320px;
    height: 320px;
    &.shoes {
      border-left: 2px solid #111;
    }
  }
`;

export const Slide = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;

  ::-webkit-scrollbar {
    display: none;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  img {
    width: 100%;
    pointer-events: none;
  }
`;

export const ArrowLeftIcon = styled.img.attrs({ src: arrowLeft })`
  width: 16px;
`;
export const ArrowRightIcon = styled.img.attrs({ src: arrowRight })`
  width: 16px;
`;

export const Actions = styled.div`
  display: flex;
`;

export const LeftButton = styled.button`
  width: 50%;
  display: flex;
  align-items: center;
  padding: 12px 24px;
  background-color: #dcdcdc;
  border: 2px solid #111;
  border-top: none;
  z-index: 999;

  &.shoes {
    border-left: 0;
  }

  @media screen and (max-width: 1140px) {
    &.shoes {
      border-left: 2px solid #111;
    }
  }
`;

export const RightButton = styled.button`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 24px;
  background-color: #dcdcdc;
  border: 2px solid #111;
  border-top: none;
  border-left: none;
  z-index: 999;
`;

export const GroupBoxes = styled.div`
  display: flex;
  column-gap: 16px;
  width: 100%;

  @media screen and (max-width: 1140px) {
    flex-direction: column;
  }
`;

export const BoxBuy = styled.div`
  width: 100%;
  height: max-content;
  max-width: 360px;
  background: #fff;
  border: 2px solid #111;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &.mobile {
    display: none;
  }

  @media screen and (max-width: 1140px) {
    max-width: 500px;
    margin-top: -2px;
    display: none;
    &.mobile {
      display: flex;
    }
  }
`;

export const BoxBuyTitle = styled.h2`
  font-family: ${fonts.BentonSansRegular};
  font-size: 22px;
  text-align: center;
  margin-bottom: 8px;
`;

export const BoxBuyPrice = styled.h3`
  font-family: ${fonts.BentonSansBold};
  font-size: 22px;
  text-align: center;
  margin-bottom: 24px;
`;

export const BoxBuyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dcdcdc;
  border: 2px solid #111;
  padding: 12px 24px;
  text-transform: uppercase;
  font-family: ${fonts.BentonSansRegular};
  font-size: 18px;
  letter-spacing: 0.5px;
  color: #111;
`;
